import React, { createContext, useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import {  useSelector } from 'react-redux';
import io from 'socket.io-client';
// import { ModalContext } from './ModalContext';


const SocketContext = createContext();

const SocketProvider = ({ children }) => {
  // const dispatch = useDispatch()
  
  const [socket, setSocket] = useState(null);
  // const { openModal, updateObj, setUpdateObj} = useContext(ModalContext);
  
  const user = useSelector((state) => state.users.user);

  useEffect(() => {
    if(!user){
      return
    }
    let userId = user.id
    let username = user.username

    const backendUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BACKEND_PROD_URL : 'http://localhost:8787';
    const socketConnection = io(backendUrl, {
      query: { userId, username },
    });
    
    setSocket(socketConnection);
    
    return () => {
      socketConnection.disconnect();
    };
  }, [user]); 




  useEffect(() => {
    if(socket){
      

      return () => {
        
        // socket.off('new_message');

      };
      
    }
  }, [socket]);



  return (
    <SocketContext.Provider value={{socket}}>
      {children}
    </SocketContext.Provider>
  );
};



export { SocketContext, SocketProvider };
 

